export const MIXINS = {
  FLEX_CENTER: `
        display: flex;
        align-items: center;
        justify-content: center;
    `,
  FILL: `
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  `
};
